export const BID_ANALYSIS_STATUS_CLOSED = 'Closed';
export const BID_ANALYSIS_STATUS_OPEN = 'Open';

/**
 * Status of a Bid Analysis
 */
export type BidAnalysisStatusType = typeof BID_ANALYSIS_STATUS_CLOSED | typeof BID_ANALYSIS_STATUS_OPEN;
